
/* eslint-disable max-len */
import React, { useEffect, useRef } from "react";
import moment from "moment-timezone";
import timezoneMapping from "./TimezoneForMapping";



export default function TimeZoneDropdown({
    label,
    id,
    placeholder,
    disabled,
    emptyField,
    selectedTimezone,
    setisOpenTimeZone,
    isOpenTimeZone,
    handleSelectionTimezone,
    setSelectedTimezone,
    searchValue,
    setSearchValue,
    timezones,
    setTimezones,
    filteredTimezones,
    setFilteredTimezones
}) {

    
    const ref = useRef();
    const dropdownRef = useRef(null);

    useEffect(() => {
        const tzList = moment.tz.names().map((tz) => {
            const offset = moment.tz(tz).utcOffset();
            const offsetSign = offset >= 0 ? '+' : '-';
            const offsetHours = Math.floor(Math.abs(offset) / 60);
            const offsetMinutes = Math.abs(offset) % 60;
            const formattedOffset = `${offsetSign}${String(offsetHours).padStart(2, '0')}:${String(offsetMinutes).padStart(2, '0')}`;
    
            const mappedTz = timezoneMapping[tz] || tz;
            const abbreviation = moment.tz(tz).format('z');
    
            return {
                timezone: tz,
                mappedTimezone: mappedTz,
                abbreviation: abbreviation,
                utcOffset: formattedOffset,
                offsetValue: offset 
            };
        });
    
        // Sort by the raw offset value
        const sortedTzList = tzList.sort((a, b) => a.offsetValue - b.offsetValue);
    
        setTimezones(sortedTzList);
        setFilteredTimezones(sortedTzList);
    }, []);
    

    // Handle search input changes and filter the timezones
    const handleSearchChange = (val) => {
        setSearchValue(val);
    
        if (val.trim() !== '') {
            const filtered = timezones.filter((tz) => {
                const searchTerm = val.toLowerCase();
    
                // Combine all fields into one composite string
                const compositeString = `${tz.mappedTimezone}: (${tz.abbreviation}) ${tz.utcOffset}`.toLowerCase();
    
                // Check for partial or full match
                return (
                    compositeString.includes(searchTerm) || // Full string match
                    tz.mappedTimezone.toLowerCase().includes(searchTerm) ||
                    tz.timezone.toLowerCase().includes(searchTerm) ||
                    tz.abbreviation.toLowerCase().includes(searchTerm) ||
                    tz.utcOffset.includes(searchTerm)
                );
            });
    
            setFilteredTimezones(filtered);
        } else {
            setFilteredTimezones(timezones);
        }
    };
    
    return (
        <>
            <div className='relative' ref={ref}>
                <label htmlFor={id} className='text-xs font-semibold text-[#000] pb-1.5'>{label}</label>
                <button
                    data-testid="timestamp-drop"
                    onClick={() =>{ setisOpenTimeZone(!isOpenTimeZone);setSearchValue('');setFilteredTimezones(timezones)}}
                    className={`border ${emptyField ? 'border-[#C81720]' : 'border-[#C5C9DA]'} disabled:bg-[#E7EAF4] rounded-lg px-3.5 py-[11px] text-base font-normal 
          text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center`}
                    disabled={disabled}
                    id={id}
                >
                    <p id={id} className={`${!selectedTimezone ? 'text-[#52555D]' : 'text-[#000B17]'} text-start text-sm more-lines`}>
                        {selectedTimezone || placeholder}
                    </p>

                    <img loading='lazy' decoding='async' src="/images/dropdown_green.svg" alt="icon" className={`${isOpenTimeZone ? "transform rotate-180" : ""}`} />
                </button>

                <ul className={`py-4 pr-1 xl:pl-4 pl-3.5 rounded-lg bg-white z-[99] absolute top-[72px] w-full left-0 border border-[#C5C9DA] ${isOpenTimeZone ? "" : "hidden"}`} ref={dropdownRef}>
                    <li>
                        <div className="relative pr-3">
                            <input
                                type="text"
                                autoComplete={"off"}
                                id={id}
                                placeholder="Search by time zone"
                                className="border border-[#C5C9DA] rounded-[16px] pl-9 px-3 py-1.5 w-full outline-none"
                                onChange={e => handleSearchChange(e.target.value)}
                                value={searchValue}
                            />
                            <img src="/images/search_gray.svg" alt="icon" className="absolute top-[50%] -translate-y-[50%] left-3" />
                        </div>
                    </li>
                    <ul className="max-h-[440px] overflow-auto scrollbar_gray pr-3">
                        {filteredTimezones.length > 0 ? (
                            filteredTimezones.map((item, i) => (
                                <li 
                                    id={`timezone-${i}`}
                                    data-testid={`timestamp-drop-${i}`}
                                    key={item.timezone} 
                                    title={`${item.mappedTimezone}: (${item.abbreviation}) ${item.utcOffset}`} 
                                    className='flex justify-between items-center xl:p-2 py-2 pr-2 pl-1'>
                                    <p
                                        onClick={() => handleSelectionTimezone(`${item.mappedTimezone}: (${item.abbreviation}) ${item.utcOffset}`)}
                                        className="text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click pl-4 more-lines hover:text-[]"
                                    >
                                        {item.mappedTimezone}: ({item.abbreviation}) {item.utcOffset}
                                    </p>
                                </li>
                            ))
                        ) : (
                            <p className="mt-2 text-center">No results found.</p>
                        )}
                    </ul>
                </ul>
            </div>
        </>
    );
}
